import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-pen_29bbf124a54c3cb0faf07a1279795b91",
  "use": "ic-pen_29bbf124a54c3cb0faf07a1279795b91-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ic-pen_29bbf124a54c3cb0faf07a1279795b91\">\n    <path d=\"M9.075 2.933l4.004 4L4.404 15.6.801 16C.4 16 0 15.6 0 15.2l.4-3.6 8.675-8.667zm6.54-.666L13.746.4c-.533-.533-1.601-.533-2.135 0L9.743 2.267l4.003 4 1.735-1.734c.668-.666.668-1.6.134-2.266z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id